import type { DataChartStyleProps } from './datachartStyleRegistry'
import './TemperatureCard.css'

export function TemperatureCardStyle02(_props: DataChartStyleProps) {
  void _props
  const temperature = 24.5
  const humidity = 45

  return (
    <div className="temperature-card temperature-card--sensor" data-css-slot="cardFrame" data-css-slot-label="Card Frame">
      <div className="temperature-card-sensor__glow is-blue" />
      <div className="temperature-card-sensor__glow is-orange" />
      <div className="temperature-card-sensor__metrics">
        <div className="temperature-card-sensor__metric">
          <div className="temperature-card-sensor__label-chip is-temperature">
            <span className="material-symbols-rounded" aria-hidden>
              thermostat
            </span>
            <span>Temp</span>
          </div>
          <div className="temperature-card-sensor__value">
            {temperature.toFixed(1)}
            <small>°C</small>
          </div>
        </div>

        <div className="temperature-card-sensor__divider" />

        <div className="temperature-card-sensor__metric">
          <div className="temperature-card-sensor__label-chip is-humidity">
            <span className="material-symbols-rounded" aria-hidden>
              water_drop
            </span>
            <span>Humidity</span>
          </div>
          <div className="temperature-card-sensor__value">
            {humidity.toFixed(0)}
            <small>%</small>
          </div>
        </div>
      </div>
    </div>
  )
}
